/**
 * Azure AD / Microsoft Entra ID Configuration
 *
 * Update these values with your Azure AD App Registration details:
 * - REACT_APP_AZURE_CLIENT_ID: Application (client) ID from Azure portal
 * - REACT_APP_AZURE_TENANT_ID: Directory (tenant) ID from Azure portal
 */

import { PublicClientApplication } from '@azure/msal-browser';

// Azure AD App Registration for GIS Demo
// Redirect URIs must be registered in Azure AD for each domain
const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || '0dc4d548-e3c6-454d-b8de-047a29d13831';
const tenantId = process.env.REACT_APP_AZURE_TENANT_ID || 'a7a76ed6-5443-493e-ab71-e4cb4301b822';
const redirectUri = process.env.REACT_APP_REDIRECT_URI || window.location.origin + '/auth/callback';

/**
 * MSAL Configuration
 */
export const msalConfig = {
  auth: {
    clientId: clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: redirectUri,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: process.env.NODE_ENV === 'development' ? 3 : 0, // Error only in prod
      piiLoggingEnabled: false,
    },
  },
};

/**
 * Scopes for ID token and access token
 */
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
};

/**
 * Scopes for Microsoft Graph API calls
 */
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};

/**
 * Allowed domain for login (only codvo.ai emails)
 */
export const allowedDomain = 'codvo.ai';

/**
 * Check if user email is from allowed domain
 */
export const isAllowedDomain = (email) => {
  if (!email) return false;
  const domain = email.split('@')[1]?.toLowerCase();
  return domain === allowedDomain;
};

/**
 * MSAL Instance - singleton for the application
 * Used by AuthProvider and apiClient for token management
 */
export const msalInstance = new PublicClientApplication(msalConfig);
